export interface BgcVotingPosition {
  id: string;
  position: string;
  selectionType: 'single' | 'multiple';
  maxSelections: number;
  nominatedPersons: Array<{ name: string; id: string }>;
}

// Replace this array with the API response when the voting endpoint is available.
export const BGC_VOTING_POSITIONS: BgcVotingPosition[] = [
  {
    "id": "chairman",
    "position": "Chairman",
    "selectionType": "single",
    "maxSelections": 1,
    "nominatedPersons": [
      {
        "name": "Natash Aston Cutinha",
        "id": "person-1"
      },
      {
        "name": "Mohammed bin Shafi Abdullah",
        "id": "person-2"
      },
      {
        "name": "Taif Sultan Al Ameri",
        "id": "person-3"
      }
    ]
  },
  {
    "id": "vice-chairman",
    "position": "Vice Chairman",
    "selectionType": "single",
    "maxSelections": 1,
    "nominatedPersons": [
      {
        "name": "Natash Aston Cutinha",
        "id": "person-1"
      },
      {
        "name": "Latifa Obaid Al-Nuaimi",
        "id": "person-4"
      }
    ]
  },
  {
    "id": "board-member",
    "position": "Board Member",
    "selectionType": "multiple",
    "maxSelections": 7,
    "nominatedPersons": [
      {
        "name": "Mariam Abdeen",
        "id": "person-5"
      },
      {
        "name": "Sheikha Musabeh Al-Ghafli",
        "id": "person-6"
      },
      {
        "name": "Hamja Mohammed Saeed",
        "id": "person-7"
      },
      {
        "name": "Natash Aston Cutinha",
        "id": "person-1"
      },
      {
        "name": "Taif Sultan Al Ameri",
        "id": "person-3"
      },
      {
        "name": "Mohammed bin Shafi Abdullah",
        "id": "person-2"
      },
      {
        "name": "Joanna Wang",
        "id": "person-8"
      },
      {
        "name": "Latifa Obaid Al-Nuaimi",
        "id": "person-4"
      }
    ]
  }
];
